import React from 'react';

import { PP_PRIMARY_COLOR } from '@/styles';

export const OFACInfoIcon = (): React.ReactElement => (
  <svg
    width="49"
    height="48"
    viewBox="0 0 49 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M43.1673 24C43.1673 34.3093 34.81 42.6667 24.5007 42.6667C14.1913 42.6667 5.83398 34.3093 5.83398 24C5.83398 13.6907 14.1913 5.33331 24.5007 5.33331C34.81 5.33331 43.1673 13.6907 43.1673 24ZM23.397 26.6177H25.6019C25.965 26.6177 26.1985 26.4058 26.2244 26.0348C26.264 25.0884 26.3157 24.1569 26.3684 23.207C26.4883 21.045 26.6135 18.7878 26.6135 16.0448V13.9514C26.6135 13.5539 26.406 13.3419 26.0169 13.3419H22.9819C22.5928 13.3419 22.3853 13.5539 22.3853 13.9514V16.0448C22.3853 18.7878 22.5105 21.0448 22.6304 23.2068C22.6831 24.1567 22.7348 25.0884 22.7744 26.0348C22.8004 26.4058 23.0338 26.6177 23.397 26.6177ZM24.5007 36C25.9734 36 27.1673 34.8061 27.1673 33.3333C27.1673 31.8606 25.9734 30.6667 24.5007 30.6667C23.0279 30.6667 21.834 31.8606 21.834 33.3333C21.834 34.8061 23.0279 36 24.5007 36Z"
      fill={PP_PRIMARY_COLOR}
    />
  </svg>
);
